import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default () => {
  return {
    path: "role-setup",
    component: withAsyncRouteLoading(() =>
      Promise.all([import("./components")]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    ),
  };
};
